<template>
    <header class="contact_banner--holder">
        <section class="contact_banner">
            <h1 class="contact_banner--title">お問い合わせ</h1>
        </section>
    </header>
</template>

<script>
export default {
    name: 'ContactBanner',
    data: () => ({
    })
}
</script>
